import React from 'react';
import '../less/notificationItem.less';

export default props => {
    return (
        <div className={`module-notification-item ${props.isError ? 'error' : 'success'}`}>
            {props.children}
        </div>
    );
};
